import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/app/(public)/[sport]/teams/[team]/[year]/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/pick/activity.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/primitives/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/primitives/icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GameProvider"] */ "/root/repo/client/src/utils/providers/game.tsx");
